import { Shield, ShieldAlert, ShieldOff, ShieldQuestion } from 'lucide-react';
import type { PermissionStatus } from '@/types';

const config: Record<PermissionStatus, { icon: typeof Shield; label: string; className: string }> = {
  granted: { icon: Shield, label: 'Granted', className: 'text-green-600 bg-green-50' },
  foreground_only: { icon: ShieldAlert, label: 'Foreground Only', className: 'text-amber-600 bg-amber-50' },
  denied: { icon: ShieldOff, label: 'Denied', className: 'text-brand-orange bg-brand-orange-light' },
  undetermined: { icon: ShieldQuestion, label: 'Undetermined', className: 'text-gray-500 bg-gray-100' },
  unknown: { icon: ShieldQuestion, label: 'Unknown', className: 'text-gray-400 bg-gray-50' },
};

interface PermissionBadgeProps {
  status: PermissionStatus;
  isPrecise: boolean;
}

export function PermissionBadge({ status, isPrecise }: PermissionBadgeProps) {
  const { icon: Icon, label, className } = config[status] ?? config.unknown;

  return (
    <div className="flex items-center gap-2">
      <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${className}`}>
        <Icon className="h-3 w-3" />
        {label}
      </span>
      {status === 'granted' && (
        <span className={`text-xs ${isPrecise ? 'text-green-600' : 'text-amber-600'}`}>
          {isPrecise ? 'Precise' : 'Approximate'}
        </span>
      )}
    </div>
  );
}
